














































































  import { GENDER } from '@/constant/Enums';
  import { Validator } from '@/constant/Mixins';
  import { Toaster } from '@/constant/Toaster';
  import { ServerResponse } from '@/services/response.types';
  import { AddressBookModel, BankAccountModel, UserModel } from '@/store/auth/types';
  import { BenefitCaryModel } from '@/store/product/kecelakaandiri/types';
  import { ProductSummaryModel } from '@/store/product/types';
  import { BSelectOption } from '@/store/types';
  import Component from 'vue-class-component';
  import { Mixins } from 'vue-property-decorator';
  import { Action, State } from 'vuex-class';

  @Component({
    name: 'UserInfoKecelakaanDiri',
    components: {},
    mixins: [],
  })
  export default class UserInfoMobil extends Mixins(Validator) {
    @Action('CheckuserAuth', { namespace: 'auth' }) CheckuserAuth!: () => Promise<ServerResponse>;
    @Action('GetAddresBook', { namespace: 'auth' }) GetAddresBook!: (params?: any) => Promise<ServerResponse>;
    @Action('GetProfile', { namespace: 'auth' }) GetProfile!: () => Promise<ServerResponse>;
    @Action('GetSummary', { namespace: 'product/kecelakaandiri' }) GetSummary!: (quotation_id: string, params?: any) => Promise<ServerResponse>;
    @Action('BuySubmitPersonalDetailProduct', { namespace: 'product/kecelakaandiri' }) BuySubmitPersonalDetailProduct!: (params: { form: FormData; quotation_id: string }) => Promise<ServerResponse>;
    @Action('GetBenefitCaries', { namespace: 'product/kecelakaandiri' }) GetBenefitCaries!: (params?: any) => Promise<ServerResponse>;

    @State('address', { namespace: 'auth' }) address: AddressBookModel[];
    @State('bank', { namespace: 'auth' }) bank: BankAccountModel[];
    @State('user', { namespace: 'auth' }) user: UserModel;
    @State('summary', { namespace: 'product/kecelakaandiri' }) summary!: ProductSummaryModel;
    @State('benefit_caries', { namespace: 'product/kecelakaandiri' }) benefit_caries!: BenefitCaryModel[];

    public addressPreview = '';
    public formPersonal = {
      first_name: '',
      last_name: '',
      idcard: '',
      gender: '',
      dob: '',
      occupation: '',
      email: '',
      phone: '',
      user_address_id: null,
      shipping_address_id: null,
      beneficiary_id: null,
      beneficiary_name: null,
    };

    public get genderList() {
      return GENDER;
    }

    public get benefitCaryList(): BSelectOption[] {
      return this.benefit_caries.map((item) => {
        return {
          text: item.beneficiary_name_ind,
          value: item.beneficiary_id,
        };
      });
    }

    public created(): void {
      window.onbeforeunload = () => {
        localStorage.setItem('kecelakaandiri-user-info-history', JSON.stringify(this.formPersonal));
      };

      let formHistory = localStorage.getItem('kecelakaandiri-user-info-history');
      if (formHistory) this.formPersonal = JSON.parse(formHistory);
      this.GetBenefitCaries();
    }

    public mounted(): void {
      this.GetProfile().then(this.SetForm);
      this.GetAddresBook().then(this.SetFormAddress);
    }

    /**
     * SetForm
     */
    public SetForm() {
      if (this.user.email) {
        this.formPersonal.first_name = this.user.first_name;
        this.formPersonal.last_name = this.user.last_name;
        this.formPersonal.phone = this.user.phone;
        this.formPersonal.email = this.user.email;
        this.formPersonal.idcard = this.user.idcard;
        this.formPersonal.occupation = this.user.occupation;
        this.formPersonal.dob = this.user.born_date;
        this.formPersonal.gender = this.user.gender;
      }
    }

    /**
     * SetFormAddress
     */
    public SetFormAddress() {
      if (this.address[0]?.address_id) {
        let addrs = this.address[0];
        this.formPersonal.user_address_id = addrs.address_id;
        this.formPersonal.shipping_address_id = addrs.address_id;
        this.addressPreview = `${addrs.address} ${addrs.zipcode}`;
      }
    }

    /**
     * OnSubmit
     */
    public OnSubmit(ev: Event) {
      if (this.formPersonal.beneficiary_id && this.formPersonal.beneficiary_name) {
        this.BuySubmitPersonalDetailProduct({ form: new FormData(ev.target as HTMLFormElement), quotation_id: this.$route.query.q as string }).then((res) => {
          this.$router.push({ name: 'personal-item-kecelakaandiri', query: this.$route.query });
        });
      } else {
        let quotation_id = this.$route.query.q as string;
        if (typeof quotation_id === 'string') this.GetSummary(quotation_id);
        else {
          this.$router.push({ name: `compare-kecelakaandiri` });
          Toaster.Warning('Transaksi tidak dapat dilanjutkan!');
        }
      }
    }
  }
